import React from 'react';
import { Clock, Copy } from 'lucide-react';
import { toast } from 'react-toastify';
import ProfileMenu from '../../common/ProfileMenu';

interface SessionHeaderProps {
    teamId: string;
    goal: string;
    elapsedMinutes?: string;
}

const SessionHeader: React.FC<SessionHeaderProps> = ({
    teamId,
    goal,
    elapsedMinutes,
}) => {
    const handleCopyLink = () => {
        const link = `${typeof window !== 'undefined' ? window.location.origin : ''}/team/${teamId}`;
        navigator.clipboard.writeText(link);
        toast.success("Invite link copied to clipboard!");
    };

    return (
        <div className="bg-white border-b border-gray-200/60 px-4 sm:px-6 py-3 flex items-center justify-between shadow-sm z-20">
            <div className="flex items-center gap-3 sm:gap-4 min-w-0">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-sm shrink-0">
                    <Clock className="w-5 h-5 sm:w-5 sm:h-5 text-white" />
                </div>
                <div className="min-w-0">
                    <div className="flex items-center gap-2">
                        <h2 className="text-base sm:text-lg font-medium text-gray-900 truncate">
                            Team Focus: {teamId}
                        </h2>
                        <button
                            onClick={handleCopyLink}
                            className="p-1 hover:bg-gray-100 rounded-md transition-colors text-gray-400 hover:text-orange-600 shrink-0"
                            title="Copy invitation link"
                        >
                            <Copy className="w-3.5 h-3.5" />
                        </button>
                    </div>
                    {goal && (
                        <p className="text-xs text-gray-500 truncate">Goal: {goal}</p>
                    )}
                </div>
            </div>
            <div className="flex items-center gap-3">
                {elapsedMinutes && (
                    <div className="flex items-center gap-2 text-sm text-black">
                        <Clock className="w-4 h-4" />
                        <span>{elapsedMinutes}</span>
                    </div>
                )}
                <ProfileMenu />
            </div>
        </div>
    );
};

export default SessionHeader;
